import { Trash2 } from "lucide-react";
import { ComponentType } from "react";
import { Button } from "@tellescope/ui";

export interface CarePlanSelectedListProps {
  ids: string[];
  emptyText: string;
  onRemove: (id: string) => void;
  ItemComponent: ComponentType<{ id: string }>;
}

export const CarePlanSelectedList = ({ ids, emptyText, onRemove, ItemComponent }: CarePlanSelectedListProps) => {
  if (!ids.length) {
    return (
      <div className="border-2 border-dashed rounded-sm flex justify-center p-3 text-sm text-muted-foreground">
        {emptyText}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {ids.map((id) => (
        <div className="rounded-md border shadow-sm py-2 px-3 flex justify-between items-center gap-1" key={id}>
          <div className="flex items-center gap-2 min-w-0 flex-1">
            <ItemComponent id={id} />
          </div>
          <Button variant="ghost" onClick={() => onRemove(id)}>
            <Trash2 className="size-3 h-auto" />
          </Button>
        </div>
      ))}
    </div>
  );
};
